(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["personalize"] && !Shopify.designMode) return;
  try {
    
  const state = {
    errorIndex: -1,
  };

  function renderError(input, message) {
    // Simple error rendering - can be customized
    input.focus();

    state.errorIndex += 1;
    const container = input.closest('fieldset');
    const errorEl = document.createElement('p');
    errorEl.className = 'personalize__error';
    errorEl.textContent = message;
    errorEl.setAttribute('id', `personalize-error-${state.errorIndex}`);
    input.setAttribute('aria-describedby', `personalize-error-${state.errorIndex}`);
    input.setAttribute('aria-invalid', 'true');
    container.appendChild(errorEl);
  }

  function clearErrors(form) {
    const errors = form.querySelectorAll('.personalize__error');
    errors.forEach((error) => error.remove());

    const inputs = form.querySelectorAll('input, select, textarea');
    inputs.forEach((input) => {
      input.removeAttribute('aria-describedby');
      input.removeAttribute('aria-invalid');
    });
  }

  function validateTextInput(input) {
    const errorMessage = input.getAttribute('data-error');
    const errorMessageInvalid = input.getAttribute('data-error-invalid');
    const value = input.value.trim();
    const maxLength = parseInt(input.getAttribute('maxlength'), 10);

    if (value.length === 0 || value.length > maxLength) {
      renderError(input, errorMessage);
      return false;
    }

    if (!/^[A-Za-z0-9\s]+$/.test(value)) {
      renderError(input, errorMessageInvalid);
      return false;
    }

    return true;
  }

  function validateColorSelection(form) {
    const selectedColor = form.querySelector('.js-personalize-color-option:checked');
    const errorMessage = form.querySelector('.js-personalize-color-option').getAttribute('data-error');

    if (!selectedColor) {
      renderError(form.querySelector('.js-personalize-color-option'), errorMessage);
      return false;
    }
    return true;
  }

  function getVariantId() {
    // Get variant ID from query params, e.g. from /products/the-debrief-short-white?variant=43165250322547
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  function slideToLastSlide() {
    const slider = document.querySelector('c-slider');
    if (!slider) {
      return;
    }
    const slidesCount = slider.slideNodes.length;
    slider.embla.scrollTo(slidesCount - 1);
  }

  function openPersonalize() {
    const personalizeSection = document.querySelector('.js-personalize');
    const productForm = document.querySelector('.product-hero__content');
    if (!personalizeSection || !productForm) return;

    personalizeSection.setAttribute('aria-hidden', 'false');
    productForm.setAttribute('aria-hidden', 'true');

    document.body.classList.add('personalize-open');

    slideToLastSlide();

    /* Focus control */
    const firstInput = personalizeSection.querySelector('input, button, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstInput) {
      firstInput.focus();
    }

    const variantId = getVariantId();
    if (variantId) {
      const personalizeIdInput = personalizeSection.querySelector('.js-personalize-id');
      if (personalizeIdInput) {
        personalizeIdInput.value = variantId;
      }

      const personalizeVariant = document.querySelector(`.js-personalize-variant[data-variant-id="${variantId}"]`);

      if (personalizeVariant) {
        const personalPrice = personalizeVariant.getAttribute('data-price');
        const personalizePriceDisplay = personalizeSection.querySelector('.js-personalize-price');
        if (personalizePriceDisplay) {
          personalizePriceDisplay.textContent = personalPrice;
        }
      }
    }

    const monogramId = getUniqueId();
    const monogramIdInput = personalizeSection.querySelector('.js-personalize-uuid');
    if (monogramIdInput) {
      monogramIdInput.value = monogramId;
    }
  }

  function closePersonalize() {
    const personalizeSection = document.querySelector('.js-personalize');
    const productForm = document.querySelector('.product-hero__content');
    document.body.classList.remove('personalize-open');

    if (!personalizeSection || !productForm) return;

    personalizeSection.setAttribute('aria-hidden', 'true');
    productForm.setAttribute('aria-hidden', 'false');
    productForm.removeAttribute('aria-hidden');

    document.querySelector('.js-personalize-open').focus();
  }

  function onColorChange(event) {
    const selectedColor = event.target.value;
    const selectedServiceId = event.target.getAttribute('data-service-id');
    const childIdInput = document.querySelector('.js-personalize-child');
    const colorDisplay = document.querySelector('.js-personalize-color');
    const colorProperty = document.querySelector('.js-personalize-monogram-color');
    if (colorDisplay) {
      colorDisplay.textContent = selectedColor;
    }

    if (childIdInput) {
      childIdInput.value = selectedServiceId;
    }

    if (colorProperty) {
      colorProperty.value = selectedColor;
    }
  }

  function onSubmit(event) {
    // Prevent default submission to allow custom handling
    event.preventDefault();
    const form = event.currentTarget;

    const actionUrl = form.getAttribute('data-action');
    if (!actionUrl) return;

    const formData = new FormData(form);
    // Process formData to support the personalization service product with parent_id

    const formDataObj = Object.fromEntries(formData.entries());

    // Get selected service ID
    const selectedServiceId = form.querySelector('input[name="properties[Embroidery color]"]:checked').getAttribute('data-service-id');

    // Process the payload -- get all properties
    const {
      form_type,
      utf8,
      'product-id': _productId,
      'variant-id[]': _variantIds,
      ...mainProduct
    } = formDataObj;

    const payload = {
      items: [
        {
          ...mainProduct,
        },
        {
          id: selectedServiceId,
          parent_id: mainProduct.id,
          quantity: 1,
        },
      ],
    };

    fetch(actionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then(response => {
      if (response.ok) {
        // Optionally handle successful addition to cart (e.g., show a message or update cart UI)
        closePersonalize();
      } else {
        // Optionally handle errors
        alert('Error adding to cart');
      }
    })
    .catch(error => {
      alert('Error adding to cart', error);
    });
  }

  function validateForm() {
    const form = document.querySelector('.js-personalize-form');

    clearErrors(form);
    let isValid = true;

    const textInput = form.querySelector('#personalization-chars');
    if (textInput) {
      isValid = validateTextInput(textInput) && isValid;
    }

    isValid = validateColorSelection(form) && isValid;

    return isValid;
  }

  function getUniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }

  function onSubmit(ev) {
    ev.preventDefault();

    const form = ev.currentTarget.closest('form');
    const textInput = form.querySelector('#personalization-chars');

    if (!validateForm()) {
      form.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', validateForm);
      });
      return false;
    } else {
      form.querySelectorAll('input').forEach((input) => {
        input.removeEventListener('change', validateForm);
      });
      cCart.submitForm(form);
      closePersonalize();
    }
  }

  function initPersonalize() {
    const toggle = document.querySelector('.js-personalize-open');
    const backButton = document.querySelector('.js-personalize-back');
    const colorOptions = document.querySelectorAll('.js-personalize-color-option');
    const form = document.querySelector('.js-personalize-form');

    if (!toggle || !backButton || !form) return;
    toggle.addEventListener('click', openPersonalize);
    backButton.addEventListener('click', closePersonalize);

    colorOptions.forEach((option) => {
      option.addEventListener('change', onColorChange);
    });

    form.setAttribute('novalidate', 'true');
    form.addEventListener('submit', onSubmit);
  }

  initPersonalize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;

		observer.unobserve(productRecommendationsSection);

		const url = productRecommendationsSection.dataset.url;

		fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
					cItemCardForm.init();
				}
			})
			.catch((e) => {
				console.error(e);
			});
	};

	const productRecommendationsSection = document.querySelector(
		'.product-recommendations'
	);

	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: '0px 0px 200px 0px',
	});

	observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
